import { Box, Sheet, Typography } from "@mui/joy";
import { useRecoilValue } from "recoil";
import { patientAtom } from "recoil/patientAtom";
import HomeTaskListForCoach from "../task-list/HomeTaskListForCoach";

export default function SidebarTaskListForCoach() {
  const selectedPatient = useRecoilValue(patientAtom);

  return (
    <Sheet
      sx={{
        width: "280px",
        height: "100%",
        overflowY: "auto",
        backgroundColor: "background.level1",
        borderColor: "divider",
      }}
    >
      {selectedPatient ? (
        <HomeTaskListForCoach />
      ) : (
        <Box sx={{ p: 2 }} alignItems={"center"}>
          <Typography variant="Caption">
            내담자를 선택해주세요.
          </Typography>
        </Box>
      )}
    </Sheet>
  );
}